import ReactComponent from './react_component'
export default ReactComponent


